export default __webpack_public_path__ + "static/media/guest_03_1_duda_almeida.019c2693.png";